import { useState } from 'react';
import rock from '../Image/rock.png'
import paper from '../Image/paper.png'
import scissors from '../Image/scissor.png'
import confetti from "canvas-confetti";
import winSound from '../sounds/win.mp3';

const Game = () => {
    const choices = ['rock', 'paper', 'scissors'];

    const choiceImage = {
        rock: rock,
        paper: paper,
        scissors: scissors
    };

    const [player, setPlayer] = useState('');
    const [computer, setComputer] = useState('');
    const [result, setResult] = useState('');
    const [playerScore, setPlayerScore] = useState(0);
    const [computerScore, setComputerScore] = useState(0);
    const [winner, setWinner] = useState('');
    const [gameOver, setGameOver] = useState(false);
    const [history, setHistory] = useState([]);
    const [streak, setStreak] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);

    const playGame = (choice) => {

        if (gameOver) return;
        setIsPlaying(true);

        setTimeout(() => {
            const randomChoice = choices[Math.floor(Math.random() * choices.length)];

            setPlayer(choice);
            setComputer(randomChoice);
            setIsPlaying(false);
            setHistory((prev) => [...prev, { player: choice, computer: randomChoice }]);

            if (choice === randomChoice) {
                setResult("Draw 🤝");
                setStreak(0);
            }
            else if (
                (choice === 'rock' && randomChoice === 'scissors') ||
                (choice === 'paper' && randomChoice === 'rock') ||
                (choice === 'scissors' && randomChoice === 'paper')
            ) {
                setPlayerScore((prev) => {
                    const newScore = prev + 1;

                    if (newScore === 5) {
                        setResult("You Won the Match! 🏆");
                        setGameOver(true);
                        const audio = new Audio(winSound);
                        audio.play();
                        confetti({
                            particleCount: 100,
                            spread: 70,
                            origin: { y: 0.6 }
                        });
                    } else {
                        setResult("You Win 🎉");
                    }
                    return newScore;
                });
                setWinner('player');
                setStreak((prev) => prev + 1);

                // setResult("Congratulations! You are the overall winner! 🎉");
                // setResult("You Win 🎉");
                // setPlayerScore(playerScore + 1);
                // setWinner('player');
                // const audio = new Audio(winSound);
                // audio.play();
                // confetti({
                //   particleCount: 100,
                //   spread: 70,
                //   origin: { y: 0.6 }
                // });
            }
            else {
                // setResult("Computer Wins 😢");
                // setComputerScore(computerScore + 1);
                setComputerScore((prev) => {
                    const newScore = prev + 1;

                    if (newScore === 5) {
                        setResult(" Computer 💻 Won the Match!");
                        setGameOver(true);
                    } else {
                        setResult("Computer Wins 😢");
                    }
                    return newScore;
                });
            }
        }, 500);
    }

    const resetGame = () => {
        setPlayer('');
        setComputer('');
        setResult('');
        setPlayerScore(0);
        setComputerScore(0);
        setGameOver(false);
    }

    return (
        <div className="min-h-screen bg-[linear-gradient(to_bottom_right,#f1ebdb,#cbc0a3,#3b2407)] flex items-center justify-center text-white">

            <div className="bg-white/10 backdrop-blur-lg p-10 rounded-2xl shadow-xl text-center w-[300px] sm:w-[400px] md:w-[500px] lg:w-[600px] px-4">

                <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold mb-6 text-[#533700]">
                    Rock Paper Scissors
                </h1>

                {/* Scoreboard */}
                <div className="flex justify-between mb-6 text-lg text-[#533700]">
                    <p className='text-sm sm:text-md md:text-md lg:text-lg'>Player: {playerScore}</p>
                    <p className='text-sm sm:text-md md:text-md lg:text-lg'>Computer: {computerScore}</p>
                </div>

                {/* Buttons */}
                <div className="flex justify-center gap-6 mb-8">

                    <button
                        onClick={() => playGame("rock")}
                        className="text-2xl sm:text-3xl md:text-4xl bg-[#533700] 
                                    h-20 sm:h-20 md:h-32
                                    w-32 sm:w-32 md:w-40
                                    px-2 sm:px-4 md:px-6
                                    rounded-xl hover:scale-105 hover:bg-[#845b0a] 
                                    transition flex justify-center items-center"
                        disabled={isPlaying}
                    >
                        <div className='flex justify-center items-center'>
                            <img src={rock} alt="Rock" className='h-10 sm:h-12 md:h-[60px] w-auto' />
                        </div>
                    </button>

                    <button
                        onClick={() => playGame("paper")}
                        className="text-2xl sm:text-3xl md:text-4xl bg-[#533700] 
                                    h-20 sm:h-20 md:h-32
                                    w-32 sm:w-32 md:w-40
                                    px-2 sm:px-4 md:px-6
                                    rounded-xl hover:scale-105 hover:bg-[#845b0a] 
                                    transition flex justify-center items-center"
                        disabled={isPlaying}
                    >
                        {/* 📄 */}
                        <div className='flex justify-center items-center'>
                            <img src={paper} alt='Paper' className='h-10 sm:h-12 md:h-[60px] w-auto' />
                        </div>
                    </button>

                    <button
                        onClick={() => playGame("scissors")}
                        className="text-2xl sm:text-3xl md:text-4xl bg-[#533700] 
                                    h-20 sm:h-20 md:h-32
                                    w-32 sm:w-32 md:w-40
                                    px-2 sm:px-4 md:px-6
                                    rounded-xl hover:scale-105 hover:bg-[#845b0a] 
                                    transition flex justify-center items-center"
                        disabled={isPlaying}
                    >
                        {/* ✂️ */}
                        <div className='flex justify-center items-center'>
                            <img src={scissors} alt='Scissors' className='h-10 sm:h-12 md:h-[60px] w-auto' />
                        </div>
                    </button>

                </div>

                {/* Choices */}
                {/* <div className="mb-4">
          <p>Your Choice: {player}</p>
          <p>Computer: {computer}</p>
        </div> */}
                <div className='flex justify-around items-center mb-4'>
                    <div>
                        <p className='mb-2 text-[#533700] text-sm sm:text-md md:text-md lg:text-lg'>Your Choice : </p>

                        <div className='flex justify-center'>
                            {player && <img src={choiceImage[player]} alt={player} className='h-10 sm:h-12 md:h-[60px] w-auto' />}
                        </div>

                    </div>
                    <div>
                        <p className='mb-2 text-[#533700] text-sm sm:text-md md:text-md lg:text-lg'>Computer Choice : </p>
                        <div className='flex justify-center'>
                            {
                                computer && <img src={choiceImage[computer]} alt={computer} className='h-10 sm:h-12 md:h-[60px] w-auto' />
                            }

                        </div>
                    </div>
                </div>

                {/* Result */}
                <h2 className="text-xl sm:text-3xl md:text-3xl lg:text-4xl font-semibold mb-6">
                    {result}
                </h2>

                {/* Reset */}
                <button
                    onClick={resetGame}
                    className="bg-[#533700] px-6 py-2 rounded-lg hover:bg-[#845b0a] transition"
                >
                    Reset Game
                </button>

            </div>

        </div>
    );
}

export default Game